import type { UseIccSetupTokenParams, IccSetupTokenQueryKey } from './types';

export const getIccSetupTokenKey = (
  params: UseIccSetupTokenParams,
): IccSetupTokenQueryKey => ['managedIntegration', 'iccSetupToken', params];
